'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/lib/report-client-error';

// Catastrophic boundary: only fires for errors in the root layout or
// anything not caught by a nearer segment error boundary. It REPLACES the
// root layout, so it must render its own <html>/<body>. Page-level crashes
// are caught by the scoped (public)/(trading) boundaries, which keep their
// layout — and the executor WebSocket it owns — mounted.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): JSX.Element {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error('app error', error);
    reportClientError(error);
  }, [error]);
  return (
    <html lang="en">
      <body>
        <main className="min-h-screen flex items-center justify-center p-4">
          <section className="max-w-md w-full border border-border rounded-lg bg-panel p-6 text-sm">
            <h1 className="text-base font-semibold text-err">Something went wrong</h1>
            <p className="mt-2 text-muted">
              An unexpected error interrupted this page. The team has been notified.
            </p>
            {error.digest ? (
              <p className="mt-2 text-[10px] text-muted">Error ID: {error.digest}</p>
            ) : null}
            <button
              onClick={reset}
              className="mt-4 rounded-md border border-accent px-3 py-1 text-xs text-accent hover:bg-accent/10"
            >
              Reload
            </button>
          </section>
        </main>
      </body>
    </html>
  );
}
